import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import Services from "@/components/Services";
import NextPageCta from "@/components/NextPageCta";

export default function ServicesPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="Services"
        title="Every job a"
        italic="property needs."
        blurb="Five core services, all delivered by one qualified trade. No subcontractors, no agency markup, no compromises on standards."
      />
      <Services />
      <NextPageCta to="/pricing" label="See the pricing →" sub="Honest starting prices for every service. Fixed quotes in 24 hours." />
    </Layout>
  );
}
